import React, { useRef, useState, memo, useEffect, useCallback } from 'react'
import { Alert, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MdLibraryAdd } from 'react-icons/md'
import MediaQuery from 'react-responsive'
import { emptyGuid } from '../../../utils/emptyGuid.js'
import PositionItem from './PositionItem.jsx'
import ArticleSelectModal from '../../ArticleSelect/ArticleSelectModal.jsx'
import StyledAddRowButton from '../../Buttons/StyledAddRowButton.jsx'

//import styled from 'styled-components'
//import { colors } from '../../../styles/colors'

/*
const StyledApplyButton = styled.button`
  flex: 0;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background-color: ${colors.secondary};
  border: 1px solid ${colors.gray1};
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.9em;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background-color: ${colors.gray3};
  }
  @media (max-width: 567px) {
    flex: 1;
    order: 5;
    width: 100%;
    padding: 6px 10px;
    white-space: nowrap;
  }
`
*/
const AddPosition = ({ handleAddArticle }) => {
  const { t } = useTranslation()
  const [showAddArticlesModal, setShowAddArticlesModal] = useState(false)
  const [selectedArticles, setSelectedArticles] = useState([])
  const [selectedArticleId, setSelectedArticleId] = useState(emptyGuid)
  useEffect(() => {
    if (!selectedArticles.length) {
      setSelectedArticleId(emptyGuid)
    } else {
      setSelectedArticleId(selectedArticles[0].article.id)
    }
  }, [setSelectedArticleId, selectedArticles])
  return (
    <>
      <StyledAddRowButton
        onClick={() => setShowAddArticlesModal(true)}
        disabled={false}
      >
        <MdLibraryAdd className='me-3' />
        {t('goodsReceiptPage:addPosition')}
      </StyledAddRowButton>
      {showAddArticlesModal ? (
        <ArticleSelectModal
          selectedArticles={selectedArticles}
          setSelectedArticles={setSelectedArticles}
          setShowAddArticlesModal={setShowAddArticlesModal}
          showAddArticlesModal={showAddArticlesModal}
          handleSave={() => {
            setShowAddArticlesModal(false)
            handleAddArticle(selectedArticleId)
            setSelectedArticles([])
          }}
          singleSelection={true}
          userOffices={true}
        />
      ) : null}
    </>
  )
}

const PositionList = memo(
  ({
    positions,
    addPosition,
    copyPosition,
    splitPosition,
    setPositions,
    checkInstance,
    actionMode,
    formErrors,
    resetErrorByFormKey,
  }) => {
    const [nextFocus, setNextFocus] = useState(null)
    const ref = useRef()
    const handleNextFocus = (id, name) => {
      let nextFocusParam = {
        id: id,
        name: name,
      }
      setNextFocus(nextFocusParam)
    }
    const focusInput = useCallback(() => {
      let id = nextFocus.id
      let name = nextFocus.name
      const allTagInputs = document.getElementsByTagName('input') //=>allInputs is a HTMLCollection not an Array!!!
      let allNameInputs = []
      const checkKeysExists = (elements, id) => {
        for (let i = 0; i < elements.length; i++) {
          if (!elements[i].disabled && elements[i].id === id.replace('-qc_', '-sk_')) {
            return true
          }
          if (!elements[i].disabled && elements[i].id === id.replace('-qc_', '-bk_')) {
            return true
          }
        }
        return false
      }
      for (let i = 0; i < allTagInputs.length; i++) {
        if (!allTagInputs[i].disabled) {
          /*if (allTagInputs[i].id.includes(`${name}_`)) {
            allNameInputs.push(allTagInputs[i])
          }*/
          if (allTagInputs[i].id.includes(`sk_`)) {
            allNameInputs.push(allTagInputs[i])
          }
          if (allTagInputs[i].id.includes(`bk_`)) {
            allNameInputs.push(allTagInputs[i])
          }
          if (allTagInputs[i].id.includes(`qc_`)) {
            if (name === 'quantityCounted' || !checkKeysExists(allTagInputs, allTagInputs[i].id)) {
              allNameInputs.push(allTagInputs[i])
            }
          }
        }
      }
      let foundIndex = allNameInputs.findIndex((item) => item.id === id)
      let nextfield =
        foundIndex >= 0 && allNameInputs[foundIndex + 1]
          ? allNameInputs[foundIndex + 1]
          : allNameInputs[0]
      // If found, focus the next field
      if (nextfield) {
        nextfield.focus()
      }
      setNextFocus(null)
    }, [nextFocus])

    const isStoring = () => {
      return actionMode === 'store'
    }

    const handleDeletePosition = (id) => {
      let index = positions.findIndex((item) => item.id === id)
      if (index >= 0) {
        const newPosistions = [...positions]
        newPosistions.splice(index, 1)
        setPositions(newPosistions)
      }
    }
    const handleChangePositionByKey = async (id, key, value) => {
      let index = positions.findIndex((item) => item.id === id)
      if (index >= 0) {
        const newPosistions = [...positions]
        switch (key) {
          case 'articleVariant':
            newPosistions[index].articleVariant = { id: value }
            break
          case 'enforceUpdate':
            delete newPosistions[index][key]
            break
          default:
            newPosistions[index][key] = value
            break
        }
        setPositions(newPosistions)
      }
    }

    /*const applyQuantitiesForAll = () => {
      const newPositions = positions.map((el) => ({
        ...el,
        quantityCounted: el.quantityExpected,
      }))
      setPositions(newPositions)
    }*/

    const renderPosition = (position, index, enforceListView) => {
      return (
        <PositionItem
          key={position.id}
          position={position}
          deletable={!isStoring()}
          handleCopyPosition={copyPosition}
          handleSplitPosition={splitPosition}
          handleDeletePosition={handleDeletePosition}
          handleChangePositionByKey={handleChangePositionByKey}
          handleCheckInstance={checkInstance}
          isStoring={isStoring()}
          enforceListView={enforceListView}
          index={index}
          formErrors={formErrors}
          resetErrorByFormKey={resetErrorByFormKey}
          handleNextFocus={handleNextFocus}
        />
      )
    }
    const { t } = useTranslation()
    const enforceListView = positions.some(
      (item) => !!item.article.useSerialKeys || !!item.article.useBatchKeys
    )
    useEffect(() => {
      if (nextFocus) {
        const timer = setTimeout(() => {
          focusInput()
        }, 20)
        return () => clearTimeout(timer)
      }
    }, [nextFocus, focusInput])
    return (
      <div ref={ref}>
        <h1>{t('goodsReceiptOverlayProgress:positions')}</h1>
        <div className='spacing-down'>
          {positions.length === 0 && (
            <Alert variant='info'>{t('goodsReceiptPage:noPositions')}</Alert>
          )}
          {!!formErrors['positions'] && (
            <Alert variant='danger'>{formErrors['positions']}</Alert>
          )}
          {!!enforceListView ? (
            positions.map((item, index) =>
              renderPosition(item, index, enforceListView)
            )
          ) : (
            <>
              {
                <MediaQuery maxWidth={998}>
                  {/*!!isStoring() && (
                    <div className='mb-3 px-2'>
                      <StyledApplyButton
                        variant='primary'
                        size='sm'
                        onClick={applyQuantitiesForAll}
                        type='button'
                      >
                        {t('goodsReceiptPage:applyQuantities')}
                      </StyledApplyButton>
                    </div>
                  )*/}
                  {positions.map((item, index) =>
                    renderPosition(item, index, enforceListView)
                  )}
                </MediaQuery>
              }
              {/* {
                <MediaQuery maxWidth={998}>
                  {positions.map((item, index) =>
                    renderPosition(item, index, enforceListView)
                  )}
                </MediaQuery>
              } */}
              {!!positions.length && (
                <MediaQuery minWidth={999}>
                  <Table borderless>
                    <tbody>
                      <tr>
                        <th>{t('productDetail:articleNumber')}</th>
                        <th>{t('productDetail:articleDescription')}</th>
                        <th>{t('size')}</th>
                        <th>{t('goodsReceiptPage:quantityExpected')}</th>
                        {/*!!isStoring() && (
                          <th className='d-flex justify-content-between'>
                            {t('goodsReceiptPage:quantityCounted')}
                            <StyledApplyButton
                              variant='primary'
                              size='sm'
                              onClick={applyQuantitiesForAll}
                              className='ms-2 '
                              type='button'
                            >
                              {t('goodsReceiptPage:applyQuantities')}
                            </StyledApplyButton>
                          </th>
                        )*/}
                        <th></th>
                      </tr>
                      {positions.map((item, index) =>
                        renderPosition(item, index, enforceListView)
                      )}
                    </tbody>
                  </Table>
                </MediaQuery>
              )}
            </>
          )}
          {!isStoring() && (
            <>
              <div className='mb-1' />
              <AddPosition handleAddArticle={addPosition} />
            </>
          )}
        </div>
      </div>
    )
  }
)

export default PositionList
